export const MANAGE_COLLABORATORS_PARAM = "manage-collaborators";
export const TEAM_SUMMARY_UPDATES_HASH = "#team-summary-updates";
